export default "__VITE_ASSET__BGeCrh2g__"